export default __webpack_public_path__ + "static/media/carSign.e74a8e13.svg";